import { AutoProduct } from 'src/enums/AutoProduct'

export const enterJourneyEventName = {
  [AutoProduct.Car]: {
    sem: 'tap_btn_get_quote',
    seo: 'tap_btn_CTA_widget',
  },
  [AutoProduct.Bike]: {
    sem: 'tap_btn_get_quote',
    seo: 'tap_btn_CTA_widget',
  },
}

export const enterJourneyEkind = {
  [AutoProduct.Car]: {
    sem: 'registration_number_cta_clicked',
    seo: 'new_car_widget_clicked',
  },
  [AutoProduct.Bike]: {
    sem: 'bike_reg_no_entered',
    seo: 'insure_now_cta_clicked',
  },
}

export const newFlowJourneyEventName = {
  [AutoProduct.Car]: {
    sem: 'tap_btn_newcar_get_quote',
    seo: 'tap_btn_CTA_widget',
  },
  [AutoProduct.Bike]: {
    sem: 'tap_btn_newbike_get_quote',
    seo: 'tap_btn_CTA_widget',
  },
}

export const autoProposalRedirectUrl = {
  [AutoProduct.Car]: appendUrl => `/car-journey/nsr${appendUrl}&lpSource=/n`,
  [AutoProduct.Bike]: appendUrl => `/bike-journey/nsr${appendUrl}`,
}

export const newFlowJourneyEkind = {
  [AutoProduct.Car]: {
    sem: 'brand_new_car_cta_clicked',
    seo: 'new_car_widget_clicked',
  },
  [AutoProduct.Bike]: {
    sem: 'bike_brand_new_bike_clicked',
    seo: 'new_bike_widget_clicked',
  },
}

export const autoWidgetJourney = {
  [AutoProduct.Car]: {
    sem: 'buy fresh car',
    seo: 'Car Insurance',
  },
  [AutoProduct.Bike]: {
    sem: 'buy fresh bike',
    seo: 'Two Wheeler Insurance',
  },
}

export const newFlowJourney = {
  [AutoProduct.Car]: {
    sem: 'buy new car',
    seo: 'Car Insurance',
  },
  [AutoProduct.Bike]: {
    sem: 'buy new bike',
    seo: 'Two Wheeler Insurance',
  },
}
